import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

export const gigListingsList = (params = '') => Http.get(`/admin/gigs/listings${serialize(params)}`)
export const gigListingDeactivate = (params = '') => Http.put(`/admin/gigs/listings/${params.id}/deactivate`, params)
